export const RateCardTableLabelConst = [
	'select',
	'Country ID',
	'Country Name',
	'Currency Code',
	'Excess Fee Conversation',
	'Excess Fee Notification',
	'Setup Fee',
	'Action',
];


export const RateCardTableColumnConst = [
	'select',
	'countryCode',
	'countryName',
	'currencyCode',
	'ovrUsgConversationCost',
	'ovrUsgNotificationCost',
	'setupFee',
	'action',
];
